/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cost_Calc_Max_5_OverlayInputs */



/**
* | output |
* | --- |
* | "Max 5 users on Starter" |
*
* @param {Cost_Calc_Max_5_OverlayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_calc_max_5_overlay = /** @type {((inputs?: Cost_Calc_Max_5_OverlayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Calc_Max_5_OverlayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Max. 5 Nutzer bei Starter")
	return /** @type {LocalizedString} */ ("Max 5 users on Starter")
});